module.exports = __webpack_public_path__ + "img/system3.a7a47a1b.png";